(function () {
    'use strict';

    angular
        .module('cloudApp')
        .controller('InstanceListDbhController', InstanceListDbhController);

    InstanceListDbhController.$inject = ['$state', 'Instance', 'ParseLinks', 'AlertService',
        'paginationConstants', 'pagingParams', '$interval', '$scope', 'Principal', 'Account',
        '$window', '$location', 'InviteSendService', 'DbhawkUserService', '$timeout', '$filter',
        'ngTableParams', '$http', 'InstanceActionService', 'Auth', 'toaster', 'errorConstants' ];

    function InstanceListDbhController($state, Instance, ParseLinks, AlertService,
                                       paginationConstants, pagingParams, $interval, $scope, Principal, Account,
                                       $window, $location, InviteSendService, DbhawkUserService, $timeout, $filter,
                                       ngTableParams, $http, InstanceActionService, Auth, toaster, errorConstants) {

        var vm = this;


        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.startInstance = startInstance;
        vm.contact = contact;
        vm.launchPersInstance = launchPersInstance;
		vm.showfullAccess = showfullAccess;
        vm.demoOnly = true;
        vm.sentRequest = false;
		vm.showAccess = false;
		vm.showButton = false;
        vm.allowDemoOnly = true;

        vm.instanceStartWait = false;
        vm.showInstancePanel = false;
        vm.showAccessDBHawkBtn = false;
        vm.showInviteUsersBtn = false;
        vm.maxLicenseDays = trialDays;
        vm.dynamicValue = 0;

	    vm.job = {};
        vm.jobs = [
            {name: 'IT Executive (CIO, CTO, VP Engineering, etc.)', code: 'IT_EXECUTIVE'},
            {name: 'Business Executive (CEO, COO, CMO, etc.)', code: 'BUSINESS_EXECUTIVE'},
            {name: 'Architect', code: 'ARCHITECT'},
            {name: 'Business Development / Alliance Manager', code: 'BUSINESS_DEVELOPMENT'},
            {name: 'DBA', code: 'DBA'},
            {name: 'Director / Development Manager', code: 'DIRECTOR'},
            {name: 'Product / Project Manager', code: 'PM'},
            {name: 'Software Developer / Engineer', code: 'DEVELOPER'},
            {name: 'Business Analyst', code: 'BA'},
            {name: 'Data Scientist', code: 'DATA_SCIENTIST'},
            {name: 'Student', code: 'STUDENT'},
            {name: 'Other', code: 'OTHER'}
        ];

		vm.database = [
            {name: 'Oracle', code: 'ORACLE', ticked: false},
            {name: 'SQL Server', code: 'SQL_SERVER', ticked: false},
            {name: 'MySQL', code: 'MYSQL', ticked: false},
            {name: 'PostgreSQL', code: 'POSTGRESQL', ticked: false},
			{name: 'MongoDB', code: 'MONGODB', ticked: false},
            {name: 'IBM DB2', code: 'DB2', ticked: false},
            {name: 'Greenplum', code: 'GREENPLUM', ticked: false},
            {name: 'Apache Spark', code: 'Apache_Spark', ticked: false},
            {name: 'Teradata', code: 'TERADATA', ticked: false},
            {name: 'SAP Hana', code: 'SAP_HANA', ticked: false},
            {name: 'AWS RDS', code: 'AWS_RDS', ticked: false},
            {name: 'Azure MS SQL', code: 'AZURE_MS_SQL', ticked: false},
            {name: 'Amazon Athena', code: 'Athena', ticked: false},
            {name: 'AWS DynamoDB', code: 'DynamoDB', ticked: false},
            {name: 'Cassandra', code: 'Cassandra', ticked: false},
            {name: 'Presto', code: 'Presto', ticked: false},
            {name: 'Snowflake', code: 'Snowflake', ticked: false},
            {name: 'Vertica', code: 'Vertica', ticked: false},
            {name: 'Redshift', code: 'REDSHIFT', ticked: false},
            {name: 'Hadoop Hive', code: 'HADOOP_HIVE', ticked: false},
            {name: 'Other', code: 'OTHER', ticked: false}
        ];

        vm.contactParam = {};

        /*Principal.identity().then(function(account) {
            vm.account = account;
            var id = account.id;

        });*/

        DbhawkUserService.getCompanyDetails().then(
            function (response) {
                var data = response.data;
                vm.allowDemoOnly = data.demoOnly;

            }).catch(function (response) {
            AlertService.error(response);
        });



        var tab = $location.search().tab;

        $scope.mValue = tab == null ? 'details' : tab;




        $scope.toggleRow = function (instance) {
            instance.selected = !instance.selected;
        };



        $scope.isSelected = function (instance) {
            return instance.selected;
        };

        $scope.redirectToApp = function () {
            DbhawkUserService.getRedirectToAppUrl().then(
                function (response) {
                    var data = response.data;
                    $window.open(data.urlOpen, '_blank');
                }).catch(function (response) {
                AlertService.error(response);
            });
        };

        function getAccountThen(account) {
            vm.account = account.data;
        }

        vm.contactParam.email = Principal.getUserEmail();

        vm.contactParam.installInstanceAgreement = true;

        Account.get().$promise.then(getAccountThen);

        loadAll();

        function loadAll() {

            Instance.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.instancesPeering = data;

                if (vm.totalItems == 0) {
                    $state.go('verify');
                }


                var host = $location.host;
                var protocol = $location.protocol();


                vm.instances = [];

                angular.forEach(vm.instancesPeering, function (value, key) {
                    value.instance.peering = value.peeringList;
                    value.instance.ipAddresses = value.ipAddresses;
                    vm.instances.push(value.instance);
                });


                vm.errorInstanceDetails = null;
                angular.forEach(vm.instances, function (value, key) {
                    value.signup = protocol + "://" + location.host + "/#/company?company=" + vm.account.lastName + "&instance=" + value.instanceId;
                    vm.onlyDemo = value.demoInstance;
					//vm.contactParam.company_name = value.tag;
                    vm.sentRequest = value.sentPersReq;

                    vm.instanceStatus = 'n/a';
                    vm.showInstancePanel = false;

                    if(value.status == 'stopped'){
                        vm.instanceStatus = 'stopped';
                    }else
                    /*if(value.status == 'running initializing'){
                        vm.instanceStatus = 'initializing';
                    }
                    else*/
                    if (value.status != 'N/A') {
                        vm.instanceStatus = null;
                        vm.showInstancePanel = value.status === 'running ok';
                        vm.showAccessDBHawkBtn = value.dbhawkUrl !== 'N/A';
                        vm.showInviteUsersBtn = value.dbhawkUrl !== 'N/A' && value.adminRegister === true;

                        if (value.starting === true) {
                            vm.instanceStartWait = true;
                            checkInstanceStatus(value.instanceId);
                            return;
                        }

                        DbhawkUserService.getUsersForInstance(value.instanceId).then(function (response) {
                            var data = response.data;
                            value.users = data.users;
                            value.license = data.license;
                            $scope.allUsers = data.users;
                            $scope.peerings = value.peering;
                            $scope.ipAddresses = value.ipAddresses;
                            value.selected = vm.showInstancePanel;

                            vm.dynamicValue = value.trialDays - value.license.daysRemain;

                            if(value.license.daysRemain<0){
                                value.license.daysRemain =0;
                            }



                           // $('#indicatorContainerTrial').radialIndicator();



                            DbhawkUserService.getRedirectToAppUrl().then(
                                function (response) {
                                    var data = response.data;
                                    // $window.open(data.urlOpen, '_blank');
                                    value.urlOpen = data.urlOpen;

                                }).catch(function (response) {
                                AlertService.error(response);
                            });
                        }).catch(function (response) {
                            vm.errorInstanceDetails = 'ERROR';
                        });
                    } else {
                        vm.instanceStatus = 'n/a';
                        vm.showInstancePanel = false;
                        if (value.starting === true) {
                            vm.instanceStartWait = true;
                            vm.showInstancePanel = false;
                            vm.showAccessDBHawkBtn = true;
                            vm.showInviteUsersBtn = true;
                            checkInstanceStatus(value.instanceId);
                        }
                    }
                });

                vm.page = pagingParams.page;
                vm.lastRefreshed = new Date();
            }

            function onError(error) {
                vm.errorInstance = 'ERROR';
                AlertService.error(error.data.message);
            }
        }

        $scope.getInstances = function () {
            loadAll();
        };

        /*var promise = $interval($scope.getInstances, 60*1000);

        $scope.$on('$destroy',function(){
            if(promise)
                $interval.cancel(promise);
        });*/

        vm.showAllStatuses = false;

        $scope.usersFilter = function (item) {
            if (vm.showAllStatuses) {
                return true;
            }
            else {
                return item.status == 'active';
            }
        };

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function startInstance(instance) {
            InstanceActionService.startInstance(instance.instanceId).then(function (response) {
                instance.stoppedByInactive = false;
                vm.instanceStartWait = true;
                vm.showAccessDBHawkBtn = true;
                vm.showInviteUsersBtn = true;
                checkInstanceStatus(instance.instanceId);
            }).catch(function (response) {
                vm.errorInstanceDetails = 'ERROR';
            });
        }

        function checkInstanceStatus(instanceId) {
            setTimeout(function () {
                Instance.get({id: instanceId}, function (data) {
                    if (data.status === 'running ok') {
                        $state.reload();
                    } else {
                        checkInstanceStatus(instanceId);
                    }
                });
            }, 20000);
        }

        $scope.tableParams = new ngTableParams({
            page: 1, // show first page
            count: 1, // count per page
            sorting: {
                id: 'asc' // initial sorting
            }
        }, {
            getData: function ($defer, params) {
//
                $scope.allUsers = $filter('orderBy')($scope.allUsers, params.orderBy());
                $defer.resolve($scope.allUsers.slice((params.page() - 1) * params.count(), params.page() * params.count()));

            }
        });

        $scope.tablePeeringParams = new ngTableParams({
            page: 1, // show first page
            count: 1, // count per page
            sorting: {
                peeringId: 'asc' // initial sorting
            }
        }, {
            getData: function ($defer, params) {
//
                $scope.peerings = $filter('orderBy')($scope.peerings, params.orderBy());
                $defer.resolve($scope.peerings.slice((params.page() - 1) * params.count(), params.page() * params.count()));

            }
        });

        vm.processDomain = function () {
            vm.contactParam.domain = vm.contactParam.company_name.replace(/[^a-z0-9]/gi, '').toLowerCase();
        }

        function contact (instanceId) {
            vm.errorCompanyExists = null;
            vm.error = null;
            vm.contactParam.message = "Request to install personalized instance";
			vm.contactParam.job = vm.job.selected.code;
		    vm.contactParam.dbs = [];
            /*if (vm.multipledb.databases) {
                vm.contactParam.selectedDbs = vm.multipledb.databases.map(function(a) {return a.code;}) ;
            }*/


            angular.forEach(vm.database, function (value, key) {
               if(value.checked==true){
                   vm.contactParam.dbs.push(value.code);
               }

            });



            //InstanceActionService.markSentReq(instanceId).then(function (response) {

                vm.contactParam.instanceId = instanceId;

                Auth.contactUs(vm.contactParam).then(function () {
                    vm.contactParam = {};
					vm.job.selected = '';
                    vm.error = null;
                    vm.success = 'OK';
                    vm.collapse = false;
                    vm.submitedPersReq = true;
                    vm.sentRequest = true;

					 $state.go('thank-you');

                }).catch(function (response) {
                    vm.success = null;

                    if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.COMPANY_ALREADY_USED_TYPE) {
                        vm.errorCompanyExists = 'ERROR';
                    }
                    else
                    vm.error = 'ERROR';

                    $window.scrollTo(0, 0);
                });

            /*}).catch(function (response) {
                vm.errorInstanceDetails = 'ERROR';
            });*/


        }

        function launchPersInstance() {
            $location.path('/instance-dbh');
        }

		function showfullAccess(){
			vm.showButton = true;
			vm.showAccess = true;
		}

        $scope.getStyle = function(){
            var transform = ( 'translateY(-50%) ') + 'translateX(-50%)';

            return {
                'top' : '50%',
                'bottom' : 'auto',
                'left': '50%',
                'transform': transform,
                '-moz-transform': transform,
                '-webkit-transform': transform,
                'font-size': 16 + 'px'
            };
        };
    }
})();
